var index = {
  root: {
    gap: '0.25rem',
    transitionDuration: '{transition.duration}'
  },
  icon: {
    size: '1.25rem',
    color: '{text.muted.color}',
    hoverColor: '{primary.color}',
    activeColor: '{primary.color}'
  }
};

export { index as default };
//# sourceMappingURL=index.mjs.map
